import type { ProductPricing } from "@constructorfleet/offerings-sdk";
import { formatProductPricing } from "@constructorfleet/offerings-sdk";

export function formatOfferingPricing(pricing: ProductPricing | undefined): string {
  if (!pricing) {
    return "";
  }
  return formatProductPricing(pricing);
}
